import { serverFetcher } from 'fetch-toolkit/server/serverFetcher/serverFetcher'
import { Domains } from 'monitoring/constants/domains'
import { PRODUCT_STOCK_SERVICE_URL } from 'product/constants/constants'
import type { Stock } from 'product/types/Stock'
import { getAkamaiFF } from 'utils/akamai/getAkamaiFF'
import { env } from 'utils/envManager'

import { type GetProductStockProps } from '../getProductStock'

export const getServerProductStock = async (
	params: GetProductStockProps
): Promise<Stock | null> => {
	const { productId, country } = params

	const { orchestrator: orchestratorFromAkamai } = getAkamaiFF()

	const baseUrl = `${orchestratorFromAkamai ? '/ws-online-orchestrator' : ''}/${PRODUCT_STOCK_SERVICE_URL}${productId}`

	const domain = orchestratorFromAkamai
		? env.NEXT_PUBLIC_SITE_BASE_URL
		: env.PRODUCT_SERVICE

	const url = new URL(baseUrl, domain)

	const searchParams = new URLSearchParams({
		countryIso: country.toUpperCase(),
		channelId: env.NEXT_PUBLIC_CHANNEL,
	})

	const response = await serverFetcher<Stock>({
		url,
		searchParams,
		requestConfig: {
			method: 'GET',
		},
		errorConfig: {
			domain: Domains.Product,
			message: '[Product] Failed to fetch product stock',
			custom: {
				productId,
			},
		},
	})

	if (!response?.data || typeof response.data === 'string') {
		return null
	}

	return response.data
}
